import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgbActiveModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
// import {DefaultLayoutModule } from './default-layout/default-layout.module';
import { DefaultFooterComponent } from './default-layout/default-footer/default-footer.component';
import { DefaultHeaderComponent } from './default-layout/default-header/default-header.component';
import { DefaultBodyComponent } from './default-layout/default-body/default-body.component';
import { DefaultSidebarComponent } from './default-layout/default-sidebar/default-sidebar.component';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from './shared/shared.module';
import { DefaultRightSidebarComponent } from './default-layout/default-right-sidebar/default-right-sidebar.component';
import { ApiRequestsService } from './services/api-requests.service';
import { ConfigurationService } from './services/configuration.service';
import { LoginPageComponent } from './pages/login-page/login-page.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { AuthGuard } from './services/auth.guard';
import { CommonModule } from '@angular/common';
import { AuthService } from './services/auth.service';
import { ToastrModule } from 'ngx-toastr';


@NgModule({
  declarations: [
    AppComponent,
   DefaultFooterComponent,
   DefaultHeaderComponent,
   DefaultBodyComponent,
   DefaultSidebarComponent,
   DefaultRightSidebarComponent,
   LoginPageComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    BrowserAnimationsModule,
    AppRoutingModule,FormsModule,ReactiveFormsModule,HttpClientModule,
    NgbModule,
    NgbDropdownModule,
    CommonModule,
    NgbModule,
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: 'toast-top-right',
      progressAnimation:'increasing',
    })
  ],
  providers: [ConfigurationService,ApiRequestsService,AuthGuard,AuthService,NgbActiveModal],
  bootstrap: [AppComponent],
  exports:[NgbDropdownModule]
})
export class AppModule { }
